import { isTestEnvironment } from '../utils/environment.mjs';

/**
 * Always-on indicator shown on the SEED test site.
 *
 * Rendered on every page (including the public login/signup pages) whenever
 * the app is served from the test host - see ../utils/environment.mjs. Styled
 * inline so it cannot be removed by CSS purging, and pointer-events are
 * disabled so it never intercepts clicks.
 */

const badgeStyle = {
  position: 'fixed',
  bottom: 'max(12px, env(safe-area-inset-bottom))',
  // Bottom-LEFT: on the right it sat over the corner where several pages put
  // their primary action, and being pointer-events:none it looked clickable
  // while swallowing nothing - confusing next to a real button.
  left: '12px',
  zIndex: 2147483647,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  backgroundColor: '#b45309', // amber-700
  color: '#ffffff',
  // Compact: it is informational only and sits over page content on phones.
  padding: '5px 10px',
  borderRadius: '9999px',
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
  border: '1px solid rgba(255, 255, 255, 0.35)',
  pointerEvents: 'none',
  userSelect: 'none',
};

export default function TestEnvironmentBanner() {
  if (!isTestEnvironment()) {
    return null;
  }

  return (
    // .test-chrome-floating hides this below md, where the navbar shows its
    // own TEST chip instead: pinned here it covered the bottom buttons.
    <div
      style={badgeStyle}
      className="test-chrome-floating"
      role="status"
      aria-label="Test environment"
      data-testid="test-environment-banner"
    >
      <span>TEST</span>
    </div>
  );
}
